<template>
  <div class="vx-row">
    <div class="vx-card__collapsible-content vs-con-loading__container W-1/6">
      <div class="vx-card__body custom-tbl v-table">
        <vs-table :data="attachmets" ref="orderTable">
          <template :name="{ data }" slot-scope="{ data }">
            <vs-tr v-for="i in attachmets" :key="i.id">
              <vs-td class="w-1/2">
                {{ $t("Attachment") }}
                {{ i.type == 2 ? "فایل اکسل" : "تصویر" }}
              </vs-td>
              <vs-td class="w-1/2">
                <vs-button
                  v-if="i.type == 2"
                  type="filled"
                  class="float-right"
                  id="reset-btn"
                  :href="defaultUrl + i.uri"
                  >{{ $t("DownloadExcelFile") }}</vs-button
                >
                <vs-button
                  v-else
                  type="filled"
                  class="float-right"
                  id="reset-btn"
                  @click.prevent="showImg(i)"
                  >{{ $t("Show") }}</vs-button
                >
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </div>
    <div class="W-5/6" v-if="ImagePopup">
      <div class="img-magnifier-container">
        <div id="imgForZoom"></div>
        <img
          :src="defaultUrl + modalModel"
          class="block mx-auto w-full my-0 text-center"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { URLS_CONSTANTS } from "../../../../config";
import { mapActions } from "vuex";

export default {
  data() {
    return {
      defaultUrl: URLS_CONSTANTS.assets + "Baskets/",
      attachmets: [],
      ImagePopup: false
    };
  },
  props: {
    basketId: ""
  },
  methods: {
    ...mapActions({
      fetchSaleAgentBasketImages: "basket/fetchSaleAgentBasketImages"
    }),
    showImg(i) {
      this.ImagePopup = false;
      this.modalModel = "";
      this.ImagePopup = true;
      this.modalModel = i.uri;
    },
    magnify(imgID, zoom) {
      var img, glass, w, h, bw;
      img = document.getElementById(imgID);
      /*create magnifier glass:*/
      glass = document.getElementById("imgForZoom");
      glass.setAttribute("class", "img-magnifier-glass");
      /*insert magnifier glass:*/
      img.parentElement.insertBefore(glass, img);
      /*set background properties for the magnifier glass:*/
      glass.style.backgroundImage = "url('" + img.src + "')";
      glass.style.backgroundRepeat = "no-repeat";
      glass.style.backgroundSize =
        img.width * zoom + "px " + img.height * zoom + "px";
      bw = 3;
      w = glass.offsetWidth / 2;
      h = glass.offsetHeight / 2;
      /*execute a function when someone moves the magnifier glass over the image:*/
      glass.addEventListener("mousemove", moveMagnifier);
      img.addEventListener("mousemove", moveMagnifier);
      /*and also for touch screens:*/
      glass.addEventListener("touchmove", moveMagnifier);
      img.addEventListener("touchmove", moveMagnifier);
      function moveMagnifier(e) {
        var pos, x, y;
        /*prevent any other actions that may occur when moving over the image*/
        e.preventDefault();
        /*get the cursor's x and y positions:*/
        pos = getCursorPos(e);
        x = pos.x;
        y = pos.y;
        /*prevent the magnifier glass from being positioned outside the image:*/
        if (x > img.width - w / zoom) {
          x = img.width - w / zoom;
        }
        if (x < w / zoom) {
          x = w / zoom;
        }
        if (y > img.height - h / zoom) {
          y = img.height - h / zoom;
        }
        if (y < h / zoom) {
          y = h / zoom;
        }
        /*set the position of the magnifier glass:*/
        glass.style.left = x - w + "px";
        glass.style.top = y - h + "px";
        /*display what the magnifier glass "sees":*/
        glass.style.backgroundPosition =
          "-" + (x * zoom - w + bw) + "px -" + (y * zoom - h + bw) + "px";
      }
      function getCursorPos(e) {
        var a,
          x = 0,
          y = 0;
        e = e || window.event;
        /*get the x and y positions of the image:*/
        a = img.getBoundingClientRect();
        /*calculate the cursor's x and y coordinates, relative to the image:*/
        x = e.pageX - a.left;
        y = e.pageY - a.top;
        /*consider any page scrolling:*/
        x = x - window.pageXOffset;
        y = y - window.pageYOffset;
        return { x: x, y: y };
      }
    }
  },
  mounted() {
    this.fetchSaleAgentBasketImages(this.basketId).then(r => {
      r.forEach(element => {
        this.attachmets.push({
          name: element.name,
          uri: element.uri,
          type: element.name.split(".")[1] == "xlsx" ? "2" : "1"
        });
      });
    });
  }
};
</script>

<style>
.img-magnifier-container {
  position: relative;
}

.img-magnifier-glass {
  position: absolute;
  border: 3px solid #000;
  cursor: none;
  /*Set the size of the magnifier glass:*/
  width: 100%;
  height: 50%;
}
</style>
